import React from 'react';

import { useRouter } from 'next/router';

import { useCountries } from 'i18n/hooks/useCountries';
import { SHOP_ROUTES } from 'routes';

import Image from 'next/image';
import { getDynamicRouteUrl } from 'modules/common/utils';

import { ClampText } from 'ui/components/ClampText';
import { Tag } from 'ui/components/Tag';
import { MarketplaceAPI } from 'revibe-api';
import { AspectRatio } from 'revibe-ui';

type Props = {
  seller: MarketplaceAPI.Seller;
};

export const SellerPreview = ({ seller }: Props) => {
  const router = useRouter();
  const { getCountryByCode } = useCountries();

  return (
    <div
      key={seller.id}
      className="relative cursor-pointer bg-gray-50"
      onClick={() =>
        router.push(
          getDynamicRouteUrl(SHOP_ROUTES.SELLER_SLUG, {
            slug: seller.slug,
          })
        )
      }
    >
      <AspectRatio ratio={3 / 4}>
        <Image
          src={
            seller.mkt_image ||
            'https://res.cloudinary.com/revibe/image/upload/v1639411886/home/Frame_17_ocht0g.svg'
          }
          alt={seller.name}
          fill
          className="object-cover"
        />
      </AspectRatio>
      <Tag className="absolute top-4 left-4">
        {getCountryByCode(seller.country)}
      </Tag>
      <div className="p-4 text-black">
        <p className="font-formula text-2xl uppercase">{seller.name}</p>
        <ClampText showReadMore={false} lines={3}>
          <p className="text-sm text-gray-500">{seller.description}</p>
        </ClampText>
      </div>
    </div>
  );
};
